import script from "./CalendarRecommendation.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarRecommendation.vue?vue&type=script&setup=true&lang=js"

import "./CalendarRecommendation.vue?vue&type=style&index=0&id=3e4eb27e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4eb27e"]])

export default __exports__